import React from 'react'
import { Navigate } from 'react-router-dom'
import { Box, Typography, CircularProgress } from '@mui/material'

import { useCustomTokenAuth } from '@app/helpers/hooks/auth'
import { ScreenReaderInfo } from '@app/components/common/ScreenReaderInfo'

const CustomLogin: React.FC = () => {
  const state = useCustomTokenAuth()

  if (state.redirectUrl) {
    return <Navigate to={state.redirectUrl} />
  }

  const loadingText = 'Validating User'

  return (
    <Box
      padding={10}
      display='flex'
      flexDirection='column'
      justifyContent='center'
      textAlign='center'
      height='90vh'
      alignItems='center'
    >
      {state.validating && (
        <>
          <ScreenReaderInfo ariaBusy ariaAtomic ariaLive='assertive'>
            {loadingText}
          </ScreenReaderInfo>

          <Box color='text.secondary' fontSize={'h3.fontSize'}>
            {/* a11y: decorative spinner — the text below + the live region carry the status */}
            <CircularProgress aria-hidden />
          </Box>

          {/* a11y: h6 styling without the heading role — a loading status is not a heading */}
          <Typography color='textSecondary' variant='h6' component='p'>
            {loadingText}
          </Typography>
        </>
      )}

      {/* a11y: role='alert' so an auth failure is announced without focus (SC 4.1.3) */}
      {state.error && (
        <Typography color='textSecondary' variant='h6' component='p' role='alert'>
          User validation failed. Error {state.error}
        </Typography>
      )}
    </Box>
  )
}

export default CustomLogin
